import { render } from "./DataSettings.vue?vue&type=template&id=daec43ea&scoped=true"
import script from "./DataSettings.vue?vue&type=script&lang=js"
export * from "./DataSettings.vue?vue&type=script&lang=js"

import "./DataSettings.vue?vue&type=style&index=0&id=daec43ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daec43ea"]])

export default __exports__